import { useQueryParams, StringParam, SetQuery } from 'use-query-params'
import { ContentRefreshDomain } from '@pepper/utils/src/types/domain'
import { useContentRefreshDomains } from '@pepper/ui'

import { useSelectedCompanyId } from 'utils/functions/misc'
import { SEOCountryQueryParam } from 'container/SEOTools/helpers/misc'

type StringParamType = string | null | undefined

const queryParams = {
  domain: StringParam,
  dateRange: StringParam,
  domainId: StringParam,
  country: SEOCountryQueryParam,
}

type useContentRefreshParamsReturnType = {
  setQuery: SetQuery<typeof queryParams>
  dateRange: StringParamType
  domainUrl: StringParamType
  domains: ContentRefreshDomain[]
  selectedDomain: ContentRefreshDomain | undefined
  companyId: string
  isLoading: boolean
  isFetching: boolean
}

export const useContentRefreshParams =
  (): useContentRefreshParamsReturnType => {
    const companyId = useSelectedCompanyId()
    const [{ domain, dateRange }, setQuery] = useQueryParams(queryParams)

    const {
      data: domains,
      isLoading,
      isFetching,
    } = useContentRefreshDomains(companyId)
    const selectedDomain = domains.find(d => d.domain_url === domain)

    return {
      setQuery,
      dateRange,
      selectedDomain,
      domainUrl: domain,
      domains,
      companyId,
      isLoading,
      isFetching,
    }
  }
